import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useRef, useState } from "react";

// Hooks
import { useHeaderType } from "../../overrides/venia-ui/components/Header/header";
import { Redirect } from "react-router";
import { useFooterType } from "../../overrides/venia-ui/components/Footer/footer";

// Components
import { useIntl } from "react-intl";
import ContentTitle from "../../components/ContentTitle";
import Button from "../../overrides/venia-ui/components/Button";
import PickupPoint from "../../components/PickupPoint";
import Icon from "../../components/Icon";
import { AddressAutocompleteNoForm } from "@Components/AddressAutocomplete/addressAutocompleteNoForm";
import StoreDetailsPage from "@Src_main/pages/StoreDetailsPage/storeDetailsPage";
import Widget from "../../components/Widget";
import WeglotInit from "@overrides_venia/venia-ui/components/WeglotInit/weglotInit";
import { ScrollToTopFunction } from "@Src_main/utils/scrollToTop";

// Styles
import defaultClasses from "./stores.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import { Meta, Title } from "@magento/venia-ui/lib/components/Head";
import { getFilteredSortedStores } from "@Src_main/utils/storeConfigs";
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
import { useAppContext } from "@overrides_venia/peregrine/context/app";
import useStores from "@Src_main/utils/useStores";
import { useHistory } from "@magento/venia-ui/lib/drivers";
import loadGmaps from "@Src_main/utils/GMapsJSImport";
var Stores = props => {
  useHeaderType("default-white");
  useFooterType("default");
  var [, {
    actions: {
      setPageLoaderFlag,
      removePageLoaderFlag
    }
  }] = useAppContext();
  var {
    stores
  } = useStores();
  var history = useHistory();
  var {
    cmsData
  } = props;
  var widgets = cmsData ? cmsData.widgets : [];
  var id = props.match ? props.match.params.id : null;
  var [isGeolocation, setIsGeolocation] = useState(true);
  var geolocationActiveClass = !isGeolocation ? defaultClasses[""] : defaultClasses["search_active"];
  var addressSetter = useRef();
  var [showMore, setShowMore] = useState({
    items: 6,
    totalItems: 0,
    increase: 6
  });
  var [choosedPosition, setChoosedPosition] = useState(null);
  var [allStores, setAllStores] = useState([]);
  var [shownStores, setShownStores] = useState([]);
  var {
    formatMessage
  } = useIntl();
  useEffect(() => {
    setPageLoaderFlag({
      name: "storeList",
      value: true
    });
    if (stores.length > 0) {
      var visibleStores = stores.filter(store => !store.isStoreHiddenFromList);
      setAllStores(visibleStores);
      loadGmaps(() => {
        setPageLoaderFlag({
          name: "storeList",
          value: false
        });
        ScrollToTopFunction();
      });
    }
    return () => {
      removePageLoaderFlag({
        name: "storeList"
      });
    };
  }, [stores]);
  useEffect(() => {
    if (choosedPosition && allStores) {
      var sortedStores = getFilteredSortedStores(allStores, choosedPosition).slice(0, showMore.items);
      setShownStores(sortedStores);
    } else if (allStores) {
      var _sortedStores = allStores.slice(0, showMore.items);
      setShownStores(_sortedStores);
    }
  }, [choosedPosition, allStores, showMore]);
  if (id && allStores.length > 0) {
    var store = allStores.find(_ref => {
      var {
        url_key
      } = _ref;
      return url_key === id;
    });
    if (!store) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: "/404"
      });
    }
    var backFunction = () => {
      history.push(formatMessage({
        id: "url.key.restaurants"
      }));
    };
    return /*#__PURE__*/React.createElement(StoreDetailsPage, {
      store: store,
      backFunction: backFunction
    });
  }
  var classes = mergeClasses(defaultClasses);

  //--HEADER--
  var headerWidget = widgets.find(_ref2 => {
    var {
      widget_type
    } = _ref2;
    return widget_type === "Reply\\Store\\Block\\Widget\\RistorantiPageBannerTopImgTitle";
  });

  //--CONTENT--
  var topWidgetText = widgets.find(_ref3 => {
    var {
      widget_type
    } = _ref3;
    return widget_type === "Reply\\Store\\Block\\Widget\\RistorantiPageBoxTitoloTestoCTATop";
  });
  var topWidgetCarousel = widgets.find(_ref4 => {
    var {
      widget_type
    } = _ref4;
    return widget_type === "Reply\\Store\\Block\\Widget\\RistorantiPageCarousel";
  });
  var checkPosition = () => {
    if (window.navigator.geolocation) {
      setIsGeolocation(true);
      window.navigator.geolocation.getCurrentPosition(position => {
        var _position$coords, _position$coords2;
        if (position !== null && position !== void 0 && (_position$coords = position.coords) !== null && _position$coords !== void 0 && _position$coords.latitude && position !== null && position !== void 0 && (_position$coords2 = position.coords) !== null && _position$coords2 !== void 0 && _position$coords2.longitude) {
          setChoosedPosition({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
          new google.maps.Geocoder().geocode({
            latLng: new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
          }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              addressSetter.current(results[0].formatted_address);
            }
          });
        }
      });
    }
  };
  var geolocation = /*#__PURE__*/React.createElement("button", {
    className: "geolocator uk-padding-remove ".concat(classes.geolocator),
    onClick: checkPosition
  }, isGeolocation ? /*#__PURE__*/React.createElement(Icon, {
    name: "icon-geolocator",
    color: "white"
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: "icon-geolocator",
    color: "black",
    header: true
  }));
  var handleSelectedAddressDetails = details => {
    if (details) {
      setChoosedPosition({
        latitude: details.geometry.location.lat(),
        longitude: details.geometry.location.lng()
      });
    } else setChoosedPosition(null);
    setShowMore(_objectSpread(_objectSpread({}, showMore), {}, {
      items: 6
    }));
  };
  var handleValueSetter = setter => {
    addressSetter.current = setter;
  };
  var formPickupPoint = shownStores.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-center uk-text-center search uk-padding-small ".concat(classes.search, " ").concat(geolocationActiveClass)
  }, /*#__PURE__*/React.createElement(AddressAutocompleteNoForm, {
    field: "address",
    fullAddress: true,
    before: /*#__PURE__*/React.createElement(Icon, {
      name: "icon-position",
      color: "miscusi-red"
    }),
    getValueSetter: handleValueSetter,
    getSelectedAddressDetails: handleSelectedAddressDetails,
    onChange: e => e.target.value.trim() === "" ? handleSelectedAddressDetails(null) : null
  }), geolocation), /*#__PURE__*/React.createElement("div", {
    className: "list-pickup-point uk-flex uk-flex-center uk-flex-wrap ".concat(classes.pickupPoint)
  }, shownStores.map(store => /*#__PURE__*/React.createElement("div", {
    key: store.ls_store_id
  }, /*#__PURE__*/React.createElement(PickupPoint, {
    selectable: true,
    store: store,
    choosedPosition: choosedPosition,
    showStoreHours: true,
    showDetailModal: false
  })))), allStores.length > shownStores.length ? /*#__PURE__*/React.createElement(Button, {
    onClick: () => setShowMore(_objectSpread(_objectSpread({}, showMore), {}, {
      items: showMore.items + showMore.increase
    })),
    color: "outline",
    fullScreen: false
  }, formatMessage({
    id: "restaurant.load.stores"
  })) : null) : null;
  var restaurants = /*#__PURE__*/React.createElement("div", {
    className: "restaurants ".concat(classes.restaurants)
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-padding-large-top"
  }, /*#__PURE__*/React.createElement(ContentTitle, {
    title: formatMessage({
      id: "restaurant.stores"
    }),
    subtitle: formatMessage({
      id: "restaurant.find.near.store"
    })
  }), formPickupPoint));
  var eventWidget = widgets.find(_ref5 => {
    var {
      widget_type
    } = _ref5;
    return widget_type === "Reply\\Store\\Block\\Widget\\RistorantiPageEvents";
  });
  var contactUsWidget = widgets.find(_ref6 => {
    var {
      widget_type
    } = _ref6;
    return widget_type === "Reply\\Store\\Block\\Widget\\RistorantiPageBannerTestoSfondo";
  });
  var content = /*#__PURE__*/React.createElement("div", {
    id: "sectionContent",
    className: "uk-background-cream uk-text-center content-stores section-rounded ".concat(classes.content)
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-info ".concat(classes.contentInfo)
  }, restaurants, /*#__PURE__*/React.createElement(Widget, topWidgetText), /*#__PURE__*/React.createElement(Widget, topWidgetCarousel), /*#__PURE__*/React.createElement(Widget, eventWidget), /*#__PURE__*/React.createElement(Widget, contactUsWidget)));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, null, cmsData && cmsData.meta_title + STORE_NAME), /*#__PURE__*/React.createElement(Meta, {
    name: "title",
    content: cmsData && cmsData.meta_title ? cmsData.meta_title : ""
  }), /*#__PURE__*/React.createElement(Meta, {
    name: "description",
    content: cmsData && cmsData.meta_description ? cmsData.meta_description : ""
  }), /*#__PURE__*/React.createElement(Meta, {
    name: "keywords",
    content: cmsData && cmsData.meta_keywords ? cmsData.meta_keywords : ""
  }), isOrderActive ? /*#__PURE__*/React.createElement(WeglotInit, {
    location: "stores"
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "page-stores ".concat(classes.stores)
  }, /*#__PURE__*/React.createElement(Widget, headerWidget), content));
};
export default Stores;